import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { tutorialForPath } from '../../data/tutorials';

export default function TutorialHelpLink({ compact = false }) {
  const { t } = useTranslation('tutorials');
  const location = useLocation();
  const tutorial = tutorialForPath(location.pathname);
  if (!tutorial) return null;
  const props = {
    component: Link,
    to: `/tutoriales?tutorial=${tutorial}`,
    state: { tutorialOrigin: { pathname: location.pathname, search: location.search, state: location.state } },
    color: 'inherit',
  };
  return compact
    ? <Tooltip title={t('contextHelp')}><IconButton {...props} aria-label={t('contextHelp')}
      sx={{ minWidth: 44, minHeight: 44 }}><HelpOutline /></IconButton></Tooltip>
    : <Button {...props} startIcon={<HelpOutline />} sx={{ minHeight: 44 }}>{t('contextHelp')}</Button>;
}
